<template>
  <div id="myitem">
    <!-- ...你的其他模板代码... -->
    <div id="vcomments"></div>
  </div>
</template>

<script>
import Valine from "valine"; // 引入 Valine 评论插件
export default {
	data() {
		return {
			// ...你的数据...
		};
	},
	mounted() {
		this.initValine();
	},
	methods: {
		initValine() {
			// eslint-disable-next-line no-unused-vars, no-undef
			const valine = new Valine({
				el: "#vcomments",
				appId: "9Vi8W59RcaXTWFKj9qAIKAh5-gzGzoHsz",
				appKey: "DC9k7TUhdKx1nl3bzspQONqT",
				// 其他配置项
			});
		},
	},
};
</script>

<style scoped>
/* ...你的样式... */
#vcomments {
	margin: 20px;
}
</style>
